import { c as _c } from "react/compiler-runtime";
import { Link } from "@/sanity/sanity.types";
interface LinkRendererProps {
  link: Link;
}
const LinkRenderer = t0 => {
  const $ = _c(9);
  const {
    link
  } = t0;
  let t1;
  if ($[0] !== link.href || $[1] !== link.internalRef) {
    const getHref = () => {
      if (link.href) {
        return link.href;
      }
      if (link.internalRef) {
        return `/${link.internalRef._ref}`;
      }
      return "#";
    };
    t1 = getHref();
    $[0] = link.href;
    $[1] = link.internalRef;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const t2 = link.newTab ? "_blank" : undefined;
  const t3 = link.newTab ? "noopener noreferrer" : undefined;
  let t4;
  if ($[3] !== link.ariaLabel || $[4] !== link.label || $[5] !== t1 || $[6] !== t2 || $[7] !== t3) {
    t4 = <a href={t1} target={t2} rel={t3} aria-label={link.ariaLabel} className="text-[#00698F] font-medium underline hover:text-[#004d66] transition-colors">{link.label}</a>;
    $[3] = link.ariaLabel;
    $[4] = link.label;
    $[5] = t1;
    $[6] = t2;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  return t4;
};
export default LinkRenderer;